import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { ActionButton, CancelButton } from "../Component";
import { DeleteButton, EditButton } from "../button/ActionButton";
import { UserActionType, UserPermissionType, isAllowToAccess } from "../../services/permission/permission";

export const AnnsModal = ({
  isOpen,
  toggle,
  isFooterHide,
  isShowHeaderRemove,
  title,
  loading,
  size,
  disabled,
  onClick,
  onDelete,
  onEdit,
  onCancelRota,
  ModalBodyClassName,
  headerClassName,
  actionButtonTitle = "Save",
  ...props
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered" size={size}>
      <ModalHeader toggle={toggle} className={headerClassName}>
        <div className="d-flex justify-content-between w-100">
          <span>{title} </span>
          {isShowHeaderRemove && (
            <span>
              {" "}
              <DeleteButton onDelete={onDelete} />
            </span>
          )}
          <div className="d-flex" style={{ gap:"10px"}}>
            {onEdit && (
              <span>
                <EditButton onEdit={onEdit} />
              </span>
            )}

            {onCancelRota && isAllowToAccess(UserPermissionType.rota, UserActionType.remove) && (
              <span>
                {" "}
                <DeleteButton onCancelRota={onCancelRota} />
              </span>
            )}
          </div>
        </div>
      </ModalHeader>
      <ModalBody className={ModalBodyClassName}>{props.children}</ModalBody>
      {!isFooterHide && (
        <ModalFooter>
          <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
            <li>
              {/* <button className="btn btn-primary" onClick={onSave}>
              Save
            </button> */}
              <CancelButton onCancel={toggle} />
            </li>
            <li>
              {/* <button className="btn btn-primary" onClick={onSave}>
              Save
            </button> */}
              <ActionButton title={actionButtonTitle} loading={loading} disabled={disabled} onClick={onClick} />
            </li>
          </ul>
        </ModalFooter>
      )}
    </Modal>
  );
};
